import { Row } from 'react-bootstrap';
import { Html } from '../../Component/Commons';
export function Title({ data: { props: { color, align }, html } }:any) {
    return <Row className='m-0 p-0' style={{ backgroundColor: color }}>
        <Html className="container" html={html} />
    </Row>
}